import { ReactQueryProvider } from "@libs/react-query/ReactQueryProvider";
import { config } from "@libs/config/config";
import { ReactQueryDevtools } from "react-query/devtools";
import { BrowserRouter as Router } from "react-router-dom";

import {
  BpThemeProvider,
  CenteredLargeSpinner,
  customIcons as icons,
  initializeIcons,
  registerIcons
} from "@bps/fluent-ui";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { AuthenticationProvider } from "@bps/msal";
import { ErrorAlert } from "@components/errors/ErrorAlert";
import { RoutingHub } from "./modules/routing/RoutingHub";

initializeIcons();

// register BP custom Fluent UI icons
registerIcons({
  fontFace: {
    fontFamily: "BP_custom_icons"
  },
  icons
});

const redirectUri = `${window.location.origin}${config.msal.postAuthenticateRedirectUrl}`;

const loadAppInsights = () => {
  if (config.appInsights && !config.development) {
    const appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: config.appInsights.instrumentationKey,
        enableAutoRouteTracking: true,
        extensions: [new ReactPlugin()]
      }
    });

    appInsights.loadAppInsights();
  }
};

export const App = () => {
  loadAppInsights();
  return (
    <BpThemeProvider styles={{ height: "100%" }}>
      <AuthenticationProvider
        config={{
          ...config.msal,
          redirectUri,
          postAuthenticateRedirectUrl: redirectUri
        }}
        renderSpinner={message => (
          <CenteredLargeSpinner label={message} labelPosition="bottom" />
        )}
        renderError={message => <ErrorAlert error={message} />}
      >
        <ReactQueryProvider>
          <Router basename={import.meta.env.PUBLIC_URL}>
            <RoutingHub />
          </Router>
          {config.development && <ReactQueryDevtools position="bottom-left" />}
        </ReactQueryProvider>
      </AuthenticationProvider>
    </BpThemeProvider>
  );
};
